<template>
  <div class="customer_home">
    <div class="main_table">
    <md-button class="md-raised md-primary btn_customer" @click="showAdd"> <md-icon class="md-size-2x">add</md-icon>Add Site</md-button>
        <md-table v-model="sites" md-card style="max-height:540px">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell  md-label="Site Name" >{{ item.name }}</md-table-cell>
            <md-table-cell  md-label="System " >{{ item.system ? systemName(item.system._id || item.system ) : '' }}</md-table-cell>
            <md-table-cell md-label="Description" >{{ item.description }}</md-table-cell>
            <md-table-cell md-label="Status" ><div :style="{color:item.active?'green':'red'}">{{item.active ? 'Active' : 'Inactive'}}</div></md-table-cell>
            <md-table-cell md-label="">
                <md-menu md-size="medium" md-align-trigger>
                <md-button md-menu-trigger><md-icon>more_horiz</md-icon></md-button>
                <md-menu-content>
                    <md-menu-item @click="showUpdate(item)">Update</md-menu-item>
                    <md-menu-item @click="showDelete(item)"><div style="color:red">Delete</div></md-menu-item>
                </md-menu-content>
                </md-menu>
            </md-table-cell>
            </md-table-row>
        </md-table>
    </div>
      
    <md-dialog :md-active.sync="delete_active" class="custom_dialog_container">
        <md-dialog-title >
          <label class='lb_close' @click="delete_active=false"><md-icon class="icon_close">clear</md-icon></label>
          <label class='lb-title'>Delete Site</label>
        </md-dialog-title>
        <md-dialog-content>
          <span>Do you want to delete this site?</span>
          <br>
          <span>All related data will alse be deleted.</span>
        </md-dialog-content>
        <md-dialog-actions >
          <md-button class="md-raised" @click="delete_active = false">Cancel</md-button>
          <md-button class="md-raised md-accent" @click="handleDeleteSite">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="update_active" class="dialog_updateSite custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close' @click="update_active=false;list_systems_show=false;system_selected=''"><md-icon class="icon_close ">clear</md-icon></label>
        <label class='lb-title'>Update Site</label>
      </md-dialog-title>
      <md-dialog-content>
      <form ref="updateSiteForm" class="dialog_update__texts">
        <div class="custom_input" style="margin-top:0px">
          <input type="text" v-model="tempSite.name" required>
          <label>Site Name*</label>
        </div>
        <div class="custom_input custom_input_icon">
          <div class="input_token">
            <input type="text" disabled  class="input_text" v-model="tempSite.accessKey">
            <div  class="show_icon" @click="generateAccessKey"><md-icon class="icon" >cached</md-icon></div>
          </div>
          <label>Access Key</label>
        </div>
        <div class="dialog_update__selects">
          <div class="dialog_update__select">
            <div class="system_lists" v-if="list_systems_show">
              <li v-for="item in systems" :key="item._id" @click="selectSystem(item)">
                <div >{{item.name}}</div>
              </li>
            </div>
            <md-icon class="icon">keyboard_arrow_down</md-icon>
            <div @click="list_systems_show=!list_systems_show"><input type="text" class="input_select" placeholder="System" readonly :value="system_selected ? system_selected.name : null" required></div>
            <label :style="{color:list_systems_show?'#0080F6':'#6D6E71'}">
              System*
            </label>
          </div>
        </div>
        <div class="dialog_update_logos">
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Origin</div>
             <div class="image" :style="`background-image: url(${tempSite.originalImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.originalImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'originalImage')" />
               Add file
             </label>
           </div>
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Image(75x75)</div>
             <div class="image" :style="`background-image: url(${tempSite.smallImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.smallImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'smallImage')" />
               Add file
             </label>
           </div>
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Image(181x178)</div>
             <div class="image" :style="`background-image: url(${tempSite.mediumImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.mediumImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'mediumImage')" />
               Add file
             </label>
           </div>
        </div>
        <div style="margin-top:20px">
          <label >Status</label>
          <div class="margin-top:20px">
            <md-radio v-model="tempSite.active" class="md-primary" :value="true">Active</md-radio>
            <md-radio v-model="tempSite.active" class="md-primary" :value="false">Inactive</md-radio>
          </div>
        </div>
        <div class="custom_input">
          <input type="text" v-model="tempSite.description">
          <label>Description</label>
        </div>
      </form>
      </md-dialog-content>
     
      <md-dialog-actions>
        <md-button class="md-raised" @click="update_active = false;list_systems_show=false;system_selected=''">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="handleUpdateSite">Update</md-button>
      </md-dialog-actions>
    </md-dialog>



    <md-dialog :md-active.sync="add_active" class="dialog_updateSite custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close' @click="add_active=false;system_selected='';list_systems_show=false"><md-icon class="icon_close ">clear</md-icon></label>
        <label class='lb-title'>Add Site</label>
      </md-dialog-title>
      <md-dialog-content>
      <form class="dialog_update__texts" ref="addSiteForm">
        <div class="custom_input" style="margin-top:0px">
          <input type="text" v-model="tempSite.name" required>
          <label>Site Name*</label>
        </div>
        <div class="custom_input custom_input_icon">
          <div class="input_token">
            <input type="text" disabled  class="input_text" v-model="tempSite.accessKey">
            <div  class="show_icon" @click="generateAccessKey"><md-icon class="icon" >cached</md-icon></div>
          </div>
          <label>Access Key</label>
        </div>
        <div class="dialog_update__selects" >
          <div class="dialog_update__select" >
            <div class="system_lists" v-if="list_systems_show">
              <li v-for="item in systems" :key="item._id" @click="selectSystem(item)">
                <div >{{item.name}}</div>
              </li>
            </div>
            <md-icon class="icon">keyboard_arrow_down</md-icon>
            <div @click="list_systems_show=!list_systems_show"><input type="text" class="input_select" placeholder="System" readonly :value="system_selected ? system_selected.name : null" required></div>
            <label :style="{color:list_systems_show?'#0080F6':'#6D6E71'}">
              System*
            </label>

            <!-- <select  id="test-select" v-model="system_selected" >
              <option v-for="item in systems" :key="item._id" :value="item._id">{{item.name}}</option>
            </select>
            <label for="test-select">System*</label> -->
          </div>
        </div>
        <div class="dialog_update_logos">
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Origin</div>
             <div class="image" :style="`background-image: url(${tempSite.originalImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.originalImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'originalImage')" />
               Add file
             </label>
           </div>
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Image(75x75)</div>
             <div class="image" :style="`background-image: url(${tempSite.smallImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.smallImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'smallImage')" />
               Add file
             </label>
           </div>
           <div class="dialog_update_logo">
             <div class="label" style="margin-bottom:7px">Image(181x178)</div>
             <div class="image" :style="`background-image: url(${tempSite.mediumImage});`"><md-icon style="color:#D7D7D7;" v-if="!tempSite.mediumImage">camera_alt</md-icon></div>
             <label>
               <input type="file" @change="addSiteChangeImage($event, 'mediumImage')" />
               Add file
             </label>
           </div>
        </div>
        <div style="margin-top:20px">
          <label >Status</label>
          <div class="margin-top:20px">
            <md-radio v-model="tempSite.active" class="md-primary" :value="true">Active</md-radio>
            <md-radio v-model="tempSite.active" class="md-primary" :value="false">Inactive</md-radio>
          </div>
        </div>
        <div class="custom_input">
          <input type="text" v-model="tempSite.description">
          <label>Description</label>
        </div>
      </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised" @click="add_active = false;system_selected='';list_systems_show=false">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="handleAddSite">Add</md-button>
      </md-dialog-actions>
    </md-dialog>
</div>
</template>
<script>
import request from '@/utils/request'
import resize from '@/utils/resize'

export default {
  name:'CustomerSite',
  created() {
    request('get', '/sites/all')
      .then(data => {
        this.sites = data.sites
      })
      .catch(err => console.log(err))

    request('get', '/systems')
      .then(data => {
        this.systems = data.systems
      })
      .catch(err => console.log(err))
  },
  data(){
    return{
      update_active:false,
      delete_active:false,
      add_active:false,
      list_systems_show:false,
      radio:'',
      sites: [],
      systems:[],
      system_selected:'',
      tempSite: {}
    }
    
  },
  methods:{
    showAdd() {
      this.tempSite = {
        name: '',
        description: '',
        active: true,
        accessKey: '',
        originalImage: '',
        smallImage: '',
        mediumImage: '',
        customer: null,
        system: null,
      },
      this.generateAccessKey()
      this.add_active=true
    },
    showUpdate(el){
      this.tempSite = {
        ...el
      }
      this.system_selected = el.system
      this.update_active=true;
    },
    showDelete(el){
      this.tempSite = el
      this.delete_active=true;
    },
    addSiteChangeImage(e, key) {
      let size
      let file = e.target.files[0]

      if (key == 'smallImage') {
        size = 75
      } else if (key == 'mediumImage') {
        size = 181
      } else {
        size = 512
      }

      if(file.type.match(/image.*/)) {
        resize(file, size)
          .then(dataUrl => {
            this.tempSite[key] = dataUrl
          })

      }
      else{
        alert('Please choose a image!')
      }
    },
    handleDeleteSite(){
      request('delete', `/sites/${this.tempSite._id}`)
        .then(() => {
          for (let i = 0; i < this.sites.length; i++) {
            if (this.sites[i]._id == this.tempSite._id) {
              this.sites.splice(i, 1)
              break
            }
          }
          this.delete_active=false;
        })
        .catch(err => {
          console.log(err)
          alert('Cannot delete this site because it’s using the data.')
        })
    },
    handleUpdateSite(){
      if (this.system_selected) {
        this.tempSite.system = this.system_selected._id
      } else {
        this.tempSite.system = null
      }
      if (this.$refs.updateSiteForm.reportValidity()) {
        request('put', '/sites', this.tempSite)
          .then(data => {
            for (let i = 0; i < this.systems.length; i++) {
              if (data.site.system == this.systems[i]._id) {
                data.site.system = this.systems[i]
                break
              }
            }

            for (let i = 0; i < this.sites.length; i++) {
              if (this.sites[i]._id == data.site._id) {
                this.sites[i] = data.site
                break
              }
            }
            this.system_selected='';
            this.update_active=false
          })
          .catch(err => {
            console.log(err)
            alert(err.message)
          })
      }
    },
    handleAddSite(){
      if (this.system_selected) {
        this.tempSite.system = this.system_selected._id
      }
      if (this.$refs.addSiteForm.reportValidity()) {
        request('post', '/sites', this.tempSite)
          .then(data => {
            this.sites.push(data.site)
            this.add_active = false
            this.system_selected=''
          })
          .catch(err => {
            console.log(err)
            alert(err.message)
          })
      }

    },
    selectSystem(el){
      this.system_selected=el;
      this.list_systems_show=false;
    },
    generateAccessKey() {
      const LENGTH = 24
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < LENGTH; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      this.tempSite.accessKey = result
    },
    systemName(systemId) {
      for (let i = 0; i < this.systems.length; i++) {
        if (this.systems[i]._id == systemId) {
          return this.systems[i].name
        }
      }
      return ''
    }
  },
}
</script>
<style lang="scss" >

 .dialog_updateSite{
    .dialog_update__texts{
      .dialog_update__text_logo{
        display: flex;
        flex-direction: column;
        .image_logo{
          display: flex;
          flex-direction: row;
          align-items: flex-end;
        }
        img{
          width: 120px;
          height: 70px;
          background-color: #D7D7D7;
        }
        input[type="file"] {
          display: none;
        }
        label{
          cursor: pointer;
          text-decoration: underline;
          color: #0080F7;
          margin-left: 17px;
        }
      }
      .custom_input_icon{
        .input_token{
          position: relative;
          display:flex;
          align-items: center;
          .show_icon{
            position: absolute;
            right:14px ;
            margin: auto;
            z-index: 100;
            cursor: pointer;
          }
          .md-icon:hover{
            color: #0080F7;
          }
        }
      }
      // .dialog_update__selects{
      //   margin-top: 20px;
      //   .input_select{
      //     color: black;
      //     font-size: 1rem;
      //     height: 48px;
      //     width: 100%;
      //     background-color: #ECECEC;
      //     border-width: 0px;
      //     border-radius: 2px;
      //     padding: 8px;
      //     outline: none ;
      //   }
      //   .input_select:focus{
          
      //     border:1px solid #0080F6 !important ;
      //   }
      //   .dialog_update__select{
      //     display: flex;
      //     flex-direction: column-reverse;
      //     position: relative;
      //     .icon{
      //       position: absolute;
      //       right: 0px;
      //       top:36px;
      //     }
      //     .system_lists{
      //       position: absolute;
      //       top:75px;
      //       width: 100%;
      //       background-color: white;
      //       // margin-top:5px;
      //       list-style-type: none;
      //       box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
      //       border-radius: 4px;
      //       z-index: 15;
      //       max-height:200px;
      //       overflow-y: auto;
      //       margin-bottom: 50px;
      //       li{
      //         height: 35px;
      //         display: flex;
      //         align-items:center;
      //         justify-content: space-between;
      //         font-size: 1rem;
      //         cursor: pointer;
              
      //         padding-left: 16px;
      //         padding-right: 16px;
              

      //       }
      //       li:hover{
      //         background-color: #CFECF9;
      //       }
      //     }
      //   }

      // }
      .dialog_update_logos{
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .dialog_update_logo{
          display: flex;
          flex-direction:column;
          align-items: flex-start;
          margin-right:24px;
          .image{
            background-position: center;
            background-size: cover;
            background-color: #ECECEC;
            width: 120px;
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            margin-bottom:7px
          }
          input[type="file"] {
            display: none;
          }
          label{
            cursor: pointer;
            text-decoration: underline;
            color: #0080F7;
            font-size: 0.8rem;

          }
        }
      }
      .dialog_update_radios{
          margin-top: 24px;
          .md-primary{
              margin-right: 58px;
          }
      }
      .dialog_descript{
        margin-top: 0px;
      }
    }
}

</style>